import React from 'react'
import { Dropdown } from 'semantic-ui-react'

const options = [
  { text: 'Off', value: 0 },
  { text: 'Paper', value: 1 },
  { text: 'MTGO', value: 2 },
  { text: 'Arena', value: 3 },
]

type Props = {
  value?: number
  onChange: (value: number) => void
}

const SortingDropdown = ({ value = options[0].value, onChange }: Props) => {
  const handleChange = (_e: React.SyntheticEvent<HTMLElement, Event>, { value }: any) => onChange(value)

  return (
    <div>
      <label>Filter to my collection:</label>
      <Dropdown selection fluid options={options} value={value} onChange={handleChange} />
    </div>
  )
}

export default SortingDropdown
